import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { WizFile } from '@wizbii/models';

@Directive({
  selector: 'app-file-input[appMimeTypes]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MimeTypesValidator, multi: true }],
})
export class MimeTypesValidator implements Validator {
  static readonly MIME_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  ];

  private _mimeTypes: string[];
  private onValidatorChange: () => void;

  @Input('appMimeTypes')
  set mimeTypes(mimeTypes: string[]) {
    this._mimeTypes = mimeTypes || MimeTypesValidator.MIME_TYPES;

    if (this.onValidatorChange) {
      this.onValidatorChange();
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  validate(control: { value: WizFile }): ValidationErrors | null {
    return !control.value || this._mimeTypes.includes(control.value.domFile.type) ? null : { mimeTypes: true };
  }
}
